import { useMutation } from "@tanstack/react-query";
import { useFinanceSettingsStore, useRevenueStore } from "features/finances";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useMembersStore } from "../stores";

export const createPartner = ({ churchId, partnerData }) => {
  return axios.post(`/churches/${churchId}/partners`, partnerData);
};

export const useCreatePartner = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeAddPartnerModal = useMembersStore.getState().closeAddPartnerModal;
  const returnToRevenue = useFinanceSettingsStore.getState().returnToRevenue;
  const setReturnToRevenue =
    useFinanceSettingsStore.getState().setReturnToRevenue;
  const openRecordRevenueModal =
    useRevenueStore.getState().openRecordRevenueModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("partners");
      setNotification({
        type: "success",
        message: "Partner created successfully!"
      });
      closeAddPartnerModal();
      if (returnToRevenue) {
        setReturnToRevenue(false);
        openRecordRevenueModal();
      }
    },
    ...config,
    mutationFn: createPartner
  });
};
